module.exports = __webpack_public_path__ + "static/img/build2.70d36b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/build2.png
// module id = gLZj
// module chunks = 0